import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { baseURL } from "../Config/Config";
import "./Card.css";
import Loader from "./loader";


export default function Card() {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState();
  // <Loader />
  React.useEffect(() => {
    axios
      .get(`${baseURL}rtr_base_app/category-level-list/`)
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 2000);
  }, []);
  if (!data) return null;
  if (isLoading) {
    return <Loader />
  } else {
    return (
      <div className="container">
        <div className="cards">
          <Link className="card" to={`/boshlangich/${data[0].id}`}>
            <svg
              width="48"
              height="41"
              viewBox="0 0 48 41"
              fill=""
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42.5886 8.52529H37.519V3.45567C37.519 2.55931 37.1629 1.69966 36.5291 1.06583C35.8953 0.432007 35.0356 0.0759277 34.1392 0.0759277H13.8608C12.9644 0.0759277 12.1047 0.432007 11.4709 1.06583C10.8371 1.69966 10.481 2.55931 10.481 3.45567V8.52529H5.41139C4.06685 8.52529 2.77737 9.05941 1.82663 10.0102C0.875893 10.9609 0.341774 12.2504 0.341774 13.5949V37.2531C0.341774 38.1495 0.697853 39.0092 1.33168 39.643C1.9655 40.2768 2.82516 40.6329 3.72152 40.6329H44.2785C45.1748 40.6329 46.0345 40.2768 46.6683 39.643C47.3021 39.0092 47.6582 38.1495 47.6582 37.2531V13.5949C47.6582 12.2504 47.1241 10.9609 46.1734 10.0102C45.2226 9.05941 43.9332 8.52529 42.5886 8.52529ZM13.8608 3.45567H34.1392V8.52529H13.8608V3.45567ZM44.2785 37.2531H3.72152V22.0443H17.2405V30.4936H30.7595V22.0443H44.2785V37.2531ZM20.6203 22.0443H27.3797V27.1139H20.6203V22.0443ZM3.72152 18.6645V13.5949C3.72152 13.1467 3.89956 12.7169 4.21647 12.4C4.53339 12.0831 4.96321 11.905 5.41139 11.905H42.5886C43.0368 11.905 43.4666 12.0831 43.7835 12.4C44.1004 12.7169 44.2785 13.1467 44.2785 13.5949V18.6645H3.72152Z"
                fill=""
              />
            </svg>

            <p > {data[0].title}</p>
          </Link>
          <Link className="card" to={`/boshlangich/${data[1].id}`}>
            <svg
              width="48"
              height="47"
              viewBox="0 0 48 47"
              fill=""
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M46.2 9.40588V1.88C46.2 0.840125 45.342 0 44.28 0H3.72003C2.65804 0 1.80004 0.840125 1.80004 1.88V9.40588C0.798037 9.46463 3.71756e-05 10.2812 3.71756e-05 11.28V19.0174C-0.00380525 20.4394 0.290253 21.8471 0.864037 23.1534C1.12204 23.7526 1.44004 24.3166 1.80004 24.8512V45.12C1.80004 46.154 2.65804 47 3.72003 47H44.28C45.342 47 46.2 46.1599 46.2 45.12V24.8512C46.5657 24.3153 46.879 23.7468 47.136 23.1534C47.706 21.8433 48 20.4509 48 19.0174V11.28C48 10.2812 47.202 9.46463 46.2 9.40588ZM6.12003 4.23H41.88V9.4H6.12003V4.23ZM27.84 42.7759H20.16V36.66H27.84V42.7759ZM41.904 42.7759H31.68V34.78C31.68 33.7401 30.822 32.9 29.76 32.9H18.24C17.178 32.9 16.32 33.7401 16.32 34.78V42.7759H6.12003V28.5466C6.29403 28.6289 6.47403 28.7111 6.66003 28.7816C7.99803 29.3339 9.42003 29.61 10.884 29.61C12.348 29.61 13.764 29.3339 15.108 28.7816C15.936 28.4409 16.716 28.0061 17.43 27.4832C17.442 27.4774 17.454 27.4774 17.466 27.4832C18.1822 28.0083 18.9622 28.4445 19.788 28.7816C21.126 29.3339 22.548 29.61 24.012 29.61C25.476 29.61 26.892 29.3339 28.236 28.7816C29.064 28.4409 29.844 28.0061 30.558 27.4832C30.57 27.4774 30.582 27.4774 30.594 27.4832C31.3102 28.0083 32.0902 28.4445 32.916 28.7816C34.254 29.3339 35.676 29.61 37.14 29.61C38.604 29.61 40.02 29.3339 41.364 28.7816C41.544 28.7053 41.724 28.6289 41.904 28.5466V42.7759ZM43.68 19.0174C43.68 22.5306 40.74 25.38 37.122 25.38C34.674 25.38 32.538 24.0816 31.41 22.1546C31.236 21.8609 30.924 21.6787 30.576 21.6787H30.54C30.198 21.6787 29.88 21.8609 29.706 22.1546C29.1304 23.1376 28.2992 23.9538 27.297 24.5204C26.2948 25.0869 25.1572 25.3835 24 25.38C21.558 25.38 19.428 24.0875 18.3 22.1664C18.12 21.8667 17.796 21.6787 17.442 21.6787C17.088 21.6787 16.758 21.8667 16.584 22.1664C16.005 23.1456 15.1728 23.9582 14.1711 24.5223C13.1694 25.0865 12.0336 25.3823 10.878 25.38C7.26003 25.38 4.32003 22.5306 4.32003 19.0174V13.6594C4.32003 13.6418 4.33203 13.63 4.35003 13.63H43.65C43.668 13.63 43.68 13.6418 43.68 13.6594V19.0174Z"
                fill=""
              />
            </svg>
            <p >{data[1].title}</p>
          </Link>
          <Link className="card" to={`/boshlangich/${data[2].id}`}>
            <svg
              width="48"
              height="38"
              viewBox="0 0 48 38"
              fill=""
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_2_754)">
                <path
                  d="M29.142 8.62415H41.1398V12.0695H29.142V8.62415Z"
                  fill=""
                />
                <path
                  d="M29.142 17.2375H41.1398V20.6829H29.142V17.2375Z"
                  fill=""
                />
                <path
                  d="M29.142 25.8506H41.1398V29.2959H29.142V25.8506Z"
                  fill=""
                />
                <path
                  d="M44.5679 0.0111084H3.43235C2.52348 0.0120205 1.65209 0.375302 1.00942 1.02123C0.366752 1.66715 0.00530204 2.54295 0.00439453 3.45643V34.4643C0.00530204 35.3778 0.366752 36.2536 1.00942 36.8995C1.65209 37.5454 2.52348 37.9087 3.43235 37.9096H44.5679C45.4766 37.9082 46.3477 37.5448 46.9903 36.899C47.6329 36.2532 47.9945 35.3776 47.9958 34.4643V3.45643C47.9949 2.54295 47.6335 1.66715 46.9908 1.02123C46.3481 0.375302 45.4767 0.0120205 44.5679 0.0111084ZM3.43235 3.45643H22.2861V34.4643H3.43235V3.45643ZM25.7141 34.4643V3.45643H44.5679L44.5713 34.4643H25.7141Z"
                  fill=""
                />
              </g>
              <defs>
                <clipPath id="clip0_2_754">
                  <rect width="48" height="37.92" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p >{data[2].title}</p>
          </Link>
        </div>
      </div>
    );
  }

}
